import React from 'react'

import { Grid as GridBase, Divider as DividerBase, styled } from '@mui/material'
import { ArrowDownward as ArrowDownwardBase } from '@mui/icons-material'
import { Tag as TagBase, Typography as TypographyBase } from '@chilecompra/react-kit/components'

export const Root = styled('div')`
  width: 100%;
`

export const Tag = styled(TagBase)`
  &.MuiPaper-root {
    display: inline-flex;
  }
`

export const DialogWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px;
`

export const Divider = styled(DividerBase)``

export const DownloadBreach = styled('a')`
  color: ${props => props.theme.palette.brand.black3};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  text-decoration: underline;
  width: 100%;
`

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    width: 100%;
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    width: 100%;
  }
`

export const IconArrowDownward = styled(ArrowDownwardBase)`
  color: ${props => props.theme.palette.brand.black3};
  margin: ${props => props.margin};
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.gray[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  visibility: ${props => props.visibility};

  &:hover {
    text-decoration: underline;
  }
`

export const LinkDocument = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
`

export const LinkParticipant = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  text-align: ${props => props.textAlign || 'left'};
  text-decoration: ${props => props.textDecoration || 'none'};
`

export const SellerLink = styled('a')`
  align-items: center;
  color: ${props => (props.disabled ? props.theme.palette.brand.disableFont : props.theme.palette.blue[50])};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  font-size: 14px;
  font-weight: 400;
  pointer-events: ${props => (props.disabled ? 'none' : 'visible')};
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
    text-decoration: underline;
  }
`

export const Row = styled('div')`
  text-align: center;
  width: 100%;
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const Text = styled(({ loading, ...props }) => <TypographyBase {...props} />)`
  &.MuiTypography-root {
    display: ${props => (props.loading ? 'block' : 'inline-block')};
    margin: ${props => (props.loading ? '0' : '0 30px 0 0')};

    ${props => props.theme.breakpoints.down('sm')} {
      display: block;
      margin: 0 0 10px;
    }
  }
`

export const WrapperDownloadBreach = styled('div')`
  align-items: center;
  display: flex;
  margin: 16px 0 0;
`

export const Action = styled('span')`
  color: ${props => props.theme.palette.brand.black3};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  text-decoration: underline;

  &:hover {
    color: ${props => props.theme.palette.brand.black2};
  }
`

export const NewQuoteBox = styled('div')`
  border: 1px solid ${props => props.theme.palette.gray[85]};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  grid-area: new-quote-box;
  padding: 20px;
`
export const OberverBox = styled('div')`
  background-color: ${props => props.theme.palette.yellow[95]};
  border: 1px solid ${props => props.theme.palette.gray[85]};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  grid-area: new-quote-box;
  padding: 20px;
`

export const AccessToNewQuote = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  margin: auto 0 auto auto;
`
